import {Component, Input, OnInit} from '@angular/core';
import { Program, Site } from '../../../../domain/cloud-topology';

@Component({
    selector: 'app-site-programs',
    templateUrl: './site-programs.component.html',
    standalone: false
})
export class SiteProgramsComponent implements OnInit {
  @Input() site: Site;
  @Input() programs: Program[];
  constructor() { }

  ngOnInit(): void {}
}
